
function addtocartSuggestion(productId, note) {
    const variant = document.getElementById("variants_" + productId).value;
    const formData = {
        items: [{
            id: variant,
            quantity: 1,
        }],
        note: note,
    };

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
    })
    .then(carthtml => {
        updateCartNotification('/?section_id=cart-notification-product');
        updateCartIconBubble('/?section_id=cart-icon-bubble');
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

function updateCartNotification(url) {
    fetch(url)
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
    })
    .then(carthtml => {
        document.getElementsByClassName("cart-item").innerHTML = carthtml;
        new CartNotification().open();
    })
    .catch(error => {
        console.error('AJAX request failed:', error);
    });
}

function updateCartIconBubble(url) {
    fetch(url)
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
    })
    .then(carthtml => {
        document.getElementById('cart-icon-bubble').innerHTML = carthtml;
    })
    .catch(error => {
        console.error('AJAX request failed:', error);
    });
}

function refreshSection(itemUrl) {
    var sectionId = document.querySelector('section.shopify-section.section').id;
    var extractedId = sectionId.match(/\d+/)[0]; // Extract the number from the section ID
    fetch(itemUrl + '/?section_id=template--' + extractedId + '__main', {
        method: 'GET',
        headers: {
            'Content-Type': 'text/html'
        }
    })
    .then(response => response.text())
    .then(productSectionNew => {
        // Find the section by ID and replace its HTML
        var section = document.getElementById('shopify-section-template--' + extractedId + '__main');
        section.innerHTML = productSectionNew;

    })
    .catch(error => console.error('Error:', error));

}